import { APIS } from "../../../config/apis"
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { VALIDATION_MESSAGE } from "../../../consts/validationMessage"
import { ServerRequest } from "../../../utils/apiweb"
import { onRequestError, onRequestNoSuccess } from "../../../utils/requests"
import { isValidNumber } from "../../../utils/validator"
import { FormError, FormLabel, InputNumber, Modal } from "../../common"
import { useForm, useFormErrors, useManagedContext } from "../../hooks"


const RecaudacionControlModal = ({ lote, onCancel, onConfirm }) => {
    const { setIsLoading } = useManagedContext()
    
    const [formValues, formHandle, , ] = useForm({
        importeNeto: 0
    })

    const paramsUrl = `/control/${lote.id}`
    const dataBody = {
        importeNeto: formValues.importeNeto
    }

    const ConfirmarControl = () => {
        setIsLoading(true)
        
        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.RECAUDACION_LOTE,
            paramsUrl,
            dataBody,
            () => {
                onConfirm()
                setIsLoading(false)
            },
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const getErrors = () => {
        const errors = {}
        if (!isValidNumber(formValues.importeNeto, true)) errors.importeNeto = VALIDATION_MESSAGE.REQUIRED
        return errors
    }

    const getFormatErrors = () => {
        const errors = {}
        if (formValues.importeNeto > lote.importeTotal) errors.importeNeto = 'Supera el importe total'
        return errors
    }

    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors)

    const onClickConfirm = () => {
        if (!validate()) return

        ConfirmarControl()
    }

    return (
        <Modal
            onEscape={onCancel}
            size="md"
            title={"Confirmación de control de lote"}
            body={(
                <div className='row form-basic'>
                    <div className="col-12 col-lg-6">
                        <label htmlFor="importeTotal" className="form-label">Importe total</label>
                        <InputNumber
                            precision={2}
                            name="importeTotal"
                            placeholder=""
                            className="form-control"
                            value={lote.importeTotal}
                            disabled={true}
                        />
                        <FormError />
                    </div>
                    <div className="col-12 col-lg-6">
                        <FormLabel htmlFor="importeNeto" required>Importe neto</FormLabel>
                        <InputNumber
                            precision={2}
                            name="importeNeto"
                            placeholder=""
                            className={`form-control ${errorOf('importeNeto') ? 'is-invalid' : ''}`}
                            value={formValues.importeNeto}
                            onChange={formHandle}
                        />
                        <FormError message={errorOf('importeNeto')} />
                    </div>
                </div>
            )}
            footer={(
                <div className="width-100p disp-b">
                    <button className="btn back-button m-left-5" data-dismiss="modal" onClick={onCancel}>Volver</button>
                    <button className="btn action-button" data-dismiss="modal" onClick={onClickConfirm}>Confirmar</button>
                </div>
            )}
        />
    )
}

export default RecaudacionControlModal
